import React from 'react';
import { BoxProps } from '@apia/theme';
import { useResponsiveTableContext } from './ResponsiveTableContext';
import { makeKeyHandler } from './store/selection/makeKeyHandler';
import { responsiveTableActions } from './store';

export interface IKeyHandler {
  children: React.ReactNode;
}

const NoMemoKeyHandler = (props: BoxProps) => {
  const {
    name,
    onChangeSelection,
    onRowClick,
    onSelectRows,
    SelectionHandler,
  } = useResponsiveTableContext();

  const Handler = React.useMemo(
    () =>
      SelectionHandler ||
      makeKeyHandler(responsiveTableActions, name, {
        throttleOptions: { wait: 50 },
        stateSelector: (global) => global.responsiveTableSlice[name],
      }),
    [SelectionHandler, name],
  );

  return (
    <Handler
      onChangeSelection={onChangeSelection}
      onSelectRows={onSelectRows}
      onRowClick={onRowClick}
      {...props}
    />
  );
};

export const KeyHandler = React.memo(NoMemoKeyHandler);
